'use client'

import { initMatomo } from '@/matomo/matomo.util'
import { useEffect } from 'react'

interface MatomoInitProps {
  matomoPath: any
}

export default function MatomoInit(props: MatomoInitProps) {
  useEffect(() => {
    initMatomo(props.matomoPath)
  }, [props.matomoPath])
  return null
}
